import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './_helpers/auth.guard';
import { TouchLayoutComponent } from './layouts/touch-layout/touch-layout.component';

const routes: Routes =[
  {
    path: '',
    redirectTo: 'touch-dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: TouchLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/layouts/touch-layout/touch-layout.module').then(m => m.TouchLayoutModule),
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule)
      }
    ]
  }, {
    path: '**',
    redirectTo: 'touch-dashboard'
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: true
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
